module.exports = __webpack_public_path__ + "img/icon2.15918dbd.png";